import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Grid,
  TextField,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Stepper,
  Step,
  StepLabel,
  StepContent,
  Chip,
  Divider,
  Tabs,
  Tab,
  TablePagination,
  useTheme,
  useMediaQuery,
  Autocomplete,
  IconButton,
  Tooltip,
} from '@mui/material';
import {
  Announcement as AnnouncementIcon,
  TrendingUp as TrendingUpIcon,
  Assessment as AssessmentIcon,
  History as HistoryIcon,
  Casino as CasinoIcon,
  EmojiEvents as TrophyIcon,
  Delete as DeleteIcon,
  Visibility as PreviewIcon,
  Close as CloseIcon,
  ExpandMore as ExpandMoreIcon,
  Person as PersonIcon,
  MonetizationOn as MoneyIcon,
} from '@mui/icons-material';
import { motion } from 'framer-motion';
import { matkaAPI, marketAPI } from '../../../services/api';
import { useAuth } from '../../../contexts/AuthContext';

// Full Sangam Panna mapping based on first digit
const fullSangamPanna = {
  "0": [
    "000",
    "001",
    "002",
    "003",
    "004",
    "005",
    "006",
    "007",
    "008",
    "009",
    "010",
    "011",
    "012",
    "013",
    "014",
    "015",
    "016",
    "017",
    "018",
    "019",
    "020",
    "021",
    "022",
    "023",
    "024",
    "025",
    "026",
    "027",
    "028",
    "029",
    "030",
    "031",
    "032",
    "033",
    "034",
    "035",
    "036",
    "037",
    "038",
    "039",
    "040",
    "041",
    "042",
    "043",
    "044",
    "045",
    "046",
    "047",
    "048",
    "049",
    "050",
    "051",
    "052",
    "053",
    "054",
    "055",
    "056",
    "057",
    "058",
    "059",
    "060",
    "061",
    "062",
    "063",
    "064",
    "065",
    "066",
    "067",
    "068",
    "069",
    "070",
    "071",
    "072",
    "073",
    "074",
    "075",
    "076",
    "077",
    "078",
    "079",
    "080",
    "081",
    "082",
    "083",
    "084",
    "085",
    "086",
    "087",
    "088",
    "089",
    "090",
    "091",
    "092",
    "093",
    "094",
    "095",
    "096",
    "097",
    "098",
    "099",
    "100",
    "101",
    "102",
    "103",
    "104",
    "105",
    "106",
    "107",
    "108",
    "109",
    "110",
    "120",
    "130",
    "140",
    "150",
    "160",
    "170",
    "180",
    "190",
    "200",
    "201",
    "202",
    "203",
    "204",
    "205",
    "206",
    "207",
    "208",
    "209",
    "210",
    "220",
    "230",
    "240",
    "250",
    "260",
    "270",
    "280",
    "290",
    "300",
    "301",
    "302",
    "303",
    "304",
    "305",
    "306",
    "307",
    "308",
    "309",
    "310",
    "320",
    "330",
    "340",
    "350",
    "360",
    "370",
    "380",
    "390",
    "400",
    "401",
    "402",
    "403",
    "404",
    "405",
    "406",
    "407",
    "408",
    "409",
    "410",
    "420",
    "430",
    "440",
    "450",
    "460",
    "470",
    "480",
    "490",
    "500",
    "501",
    "502",
    "503",
    "504",
    "505",
    "506",
    "507",
    "508",
    "509",
    "510",
    "520",
    "530",
    "540",
    "550",
    "560",
    "570",
    "580",
    "590",
    "600",
    "601",
    "602",
    "603",
    "604",
    "605",
    "606",
    "607",
    "608",
    "609",
    "610",
    "620",
    "630",
    "640",
    "650",
    "660",
    "670",
    "680",
    "690",
    "700",
    "701",
    "702",
    "703",
    "704",
    "705",
    "706",
    "707",
    "708",
    "709",
    "710",
    "720",
    "730",
    "740",
    "750",
    "760",
    "770",
    "780",
    "790",
    "800",
    "801",
    "802",
    "803",
    "804",
    "805",
    "806",
    "807",
    "808",
    "809",
    "810",
    "820",
    "830",
    "840",
    "850",
    "860",
    "870",
    "880",
    "890",
    "900",
    "901",
    "902",
    "903",
    "904",
    "905",
    "906",
    "907",
    "908",
    "909",
    "910",
    "920",
    "930",
    "940",
    "950",
    "960",
    "970",
    "980",
    "990"
  ],
  "1": [
    "001",
    "010",
    "011",
    "012",
    "013",
    "014",
    "015",
    "016",
    "017",
    "018",
    "019",
    "021",
    "031",
    "041",
    "051",
    "061",
    "071",
    "081",
    "091",
    "100",
    "101",
    "102",
    "103",
    "104",
    "105",
    "106",
    "107",
    "108",
    "109",
    "110",
    "111",
    "112",
    "113",
    "114",
    "115",
    "116",
    "117",
    "118",
    "119",
    "120",
    "121",
    "122",
    "123",
    "124",
    "125",
    "126",
    "127",
    "128",
    "129",
    "130",
    "131",
    "132",
    "133",
    "134",
    "135",
    "136",
    "137",
    "138",
    "139",
    "140",
    "141",
    "142",
    "143",
    "144",
    "145",
    "146",
    "147",
    "148",
    "149",
    "150",
    "151",
    "152",
    "153",
    "154",
    "155",
    "156",
    "157",
    "158",
    "159",
    "160",
    "161",
    "162",
    "163",
    "164",
    "165",
    "166",
    "167",
    "168",
    "169",
    "170",
    "171",
    "172",
    "173",
    "174",
    "175",
    "176",
    "177",
    "178",
    "179",
    "180",
    "181",
    "182",
    "183",
    "184",
    "185",
    "186",
    "187",
    "188",
    "189",
    "190",
    "191",
    "192",
    "193",
    "194",
    "195",
    "196",
    "197",
    "198",
    "199",
    "201",
    "210",
    "211",
    "212",
    "213",
    "214",
    "215",
    "216",
    "217",
    "218",
    "219",
    "221",
    "231",
    "241",
    "251",
    "261",
    "271",
    "281",
    "291",
    "301",
    "310",
    "311",
    "312",
    "313",
    "314",
    "315",
    "316",
    "317",
    "318",
    "319",
    "321",
    "331",
    "341",
    "351",
    "361",
    "371",
    "381",
    "391",
    "401",
    "410",
    "411",
    "412",
    "413",
    "414",
    "415",
    "416",
    "417",
    "418",
    "419",
    "421",
    "431",
    "441",
    "451",
    "461",
    "471",
    "481",
    "491",
    "501",
    "510",
    "511",
    "512",
    "513",
    "514",
    "515",
    "516",
    "517",
    "518",
    "519",
    "521",
    "531",
    "541",
    "551",
    "561",
    "571",
    "581",
    "591",
    "601",
    "610",
    "611",
    "612",
    "613",
    "614",
    "615",
    "616",
    "617",
    "618",
    "619",
    "621",
    "631",
    "641",
    "651",
    "661",
    "671",
    "681",
    "691",
    "701",
    "710",
    "711",
    "712",
    "713",
    "714",
    "715",
    "716",
    "717",
    "718",
    "719",
    "721",
    "731",
    "741",
    "751",
    "761",
    "771",
    "781",
    "791",
    "801",
    "810",
    "811",
    "812",
    "813",
    "814",
    "815",
    "816",
    "817",
    "818",
    "819",
    "821",
    "831",
    "841",
    "851",
    "861",
    "871",
    "881",
    "891",
    "901",
    "910",
    "911",
    "912",
    "913",
    "914",
    "915",
    "916",
    "917",
    "918",
    "919",
    "921",
    "931",
    "941",
    "951",
    "961",
    "971",
    "981",
    "991"
  ],
  "2": [
    "002",
    "012",
    "020",
    "021",
    "022",
    "023",
    "024",
    "025",
    "026",
    "027",
    "028",
    "029",
    "032",
    "042",
    "052",
    "062",
    "072",
    "082",
    "092",
    "102",
    "112",
    "120",
    "121",
    "122",
    "123",
    "124",
    "125",
    "126",
    "127",
    "128",
    "129",
    "132",
    "142",
    "152",
    "162",
    "172",
    "182",
    "192",
    "200",
    "201",
    "202",
    "203",
    "204",
    "205",
    "206",
    "207",
    "208",
    "209",
    "210",
    "211",
    "212",
    "213",
    "214",
    "215",
    "216",
    "217",
    "218",
    "219",
    "220",
    "221",
    "222",
    "223",
    "224",
    "225",
    "226",
    "227",
    "228",
    "229",
    "230",
    "231",
    "232",
    "233",
    "234",
    "235",
    "236",
    "237",
    "238",
    "239",
    "240",
    "241",
    "242",
    "243",
    "244",
    "245",
    "246",
    "247",
    "248",
    "249",
    "250",
    "251",
    "252",
    "253",
    "254",
    "255",
    "256",
    "257",
    "258",
    "259",
    "260",
    "261",
    "262",
    "263",
    "264",
    "265",
    "266",
    "267",
    "268",
    "269",
    "270",
    "271",
    "272",
    "273",
    "274",
    "275",
    "276",
    "277",
    "278",
    "279",
    "280",
    "281",
    "282",
    "283",
    "284",
    "285",
    "286",
    "287",
    "288",
    "289",
    "290",
    "291",
    "292",
    "293",
    "294",
    "295",
    "296",
    "297",
    "298",
    "299",
    "302",
    "312",
    "320",
    "321",
    "322",
    "323",
    "324",
    "325",
    "326",
    "327",
    "328",
    "329",
    "332",
    "342",
    "352",
    "362",
    "372",
    "382",
    "392",
    "402",
    "412",
    "420",
    "421",
    "422",
    "423",
    "424",
    "425",
    "426",
    "427",
    "428",
    "429",
    "432",
    "442",
    "452",
    "462",
    "472",
    "482",
    "492",
    "502",
    "512",
    "520",
    "521",
    "522",
    "523",
    "524",
    "525",
    "526",
    "527",
    "528",
    "529",
    "532",
    "542",
    "552",
    "562",
    "572",
    "582",
    "592",
    "602",
    "612",
    "620",
    "621",
    "622",
    "623",
    "624",
    "625",
    "626",
    "627",
    "628",
    "629",
    "632",
    "642",
    "652",
    "662",
    "672",
    "682",
    "692",
    "702",
    "712",
    "720",
    "721",
    "722",
    "723",
    "724",
    "725",
    "726",
    "727",
    "728",
    "729",
    "732",
    "742",
    "752",
    "762",
    "772",
    "782",
    "792",
    "802",
    "812",
    "820",
    "821",
    "822",
    "823",
    "824",
    "825",
    "826",
    "827",
    "828",
    "829",
    "832",
    "842",
    "852",
    "862",
    "872",
    "882",
    "892",
    "902",
    "912",
    "920",
    "921",
    "922",
    "923",
    "924",
    "925",
    "926",
    "927",
    "928",
    "929",
    "932",
    "942",
    "952",
    "962",
    "972",
    "982",
    "992"
  ],
  "3": [
    "003",
    "013",
    "023",
    "030",
    "031",
    "032",
    "033",
    "034",
    "035",
    "036",
    "037",
    "038",
    "039",
    "043",
    "053",
    "063",
    "073",
    "083",
    "093",
    "103",
    "113",
    "123",
    "130",
    "131",
    "132",
    "133",
    "134",
    "135",
    "136",
    "137",
    "138",
    "139",
    "143",
    "153",
    "163",
    "173",
    "183",
    "193",
    "203",
    "213",
    "223",
    "230",
    "231",
    "232",
    "233",
    "234",
    "235",
    "236",
    "237",
    "238",
    "239",
    "243",
    "253",
    "263",
    "273",
    "283",
    "293",
    "300",
    "301",
    "302",
    "303",
    "304",
    "305",
    "306",
    "307",
    "308",
    "309",
    "310",
    "311",
    "312",
    "313",
    "314",
    "315",
    "316",
    "317",
    "318",
    "319",
    "320",
    "321",
    "322",
    "323",
    "324",
    "325",
    "326",
    "327",
    "328",
    "329",
    "330",
    "331",
    "332",
    "333",
    "334",
    "335",
    "336",
    "337",
    "338",
    "339",
    "340",
    "341",
    "342",
    "343",
    "344",
    "345",
    "346",
    "347",
    "348",
    "349",
    "350",
    "351",
    "352",
    "353",
    "354",
    "355",
    "356",
    "357",
    "358",
    "359",
    "360",
    "361",
    "362",
    "363",
    "364",
    "365",
    "366",
    "367",
    "368",
    "369",
    "370",
    "371",
    "372",
    "373",
    "374",
    "375",
    "376",
    "377",
    "378",
    "379",
    "380",
    "381",
    "382",
    "383",
    "384",
    "385",
    "386",
    "387",
    "388",
    "389",
    "390",
    "391",
    "392",
    "393",
    "394",
    "395",
    "396",
    "397",
    "398",
    "399",
    "403",
    "413",
    "423",
    "430",
    "431",
    "432",
    "433",
    "434",
    "435",
    "436",
    "437",
    "438",
    "439",
    "443",
    "453",
    "463",
    "473",
    "483",
    "493",
    "503",
    "513",
    "523",
    "530",
    "531",
    "532",
    "533",
    "534",
    "535",
    "536",
    "537",
    "538",
    "539",
    "543",
    "553",
    "563",
    "573",
    "583",
    "593",
    "603",
    "613",
    "623",
    "630",
    "631",
    "632",
    "633",
    "634",
    "635",
    "636",
    "637",
    "638",
    "639",
    "643",
    "653",
    "663",
    "673",
    "683",
    "693",
    "703",
    "713",
    "723",
    "730",
    "731",
    "732",
    "733",
    "734",
    "735",
    "736",
    "737",
    "738",
    "739",
    "743",
    "753",
    "763",
    "773",
    "783",
    "793",
    "803",
    "813",
    "823",
    "830",
    "831",
    "832",
    "833",
    "834",
    "835",
    "836",
    "837",
    "838",
    "839",
    "843",
    "853",
    "863",
    "873",
    "883",
    "893",
    "903",
    "913",
    "923",
    "930",
    "931",
    "932",
    "933",
    "934",
    "935",
    "936",
    "937",
    "938",
    "939",
    "943",
    "953",
    "963",
    "973",
    "983",
    "993"
  ],
  "4": [
    "004",
    "014",
    "024",
    "034",
    "040",
    "041",
    "042",
    "043",
    "044",
    "045",
    "046",
    "047",
    "048",
    "049",
    "054",
    "064",
    "074",
    "084",
    "094",
    "104",
    "114",
    "124",
    "134",
    "140",
    "141",
    "142",
    "143",
    "144",
    "145",
    "146",
    "147",
    "148",
    "149",
    "154",
    "164",
    "174",
    "184",
    "194",
    "204",
    "214",
    "224",
    "234",
    "240",
    "241",
    "242",
    "243",
    "244",
    "245",
    "246",
    "247",
    "248",
    "249",
    "254",
    "264",
    "274",
    "284",
    "294",
    "304",
    "314",
    "324",
    "334",
    "340",
    "341",
    "342",
    "343",
    "344",
    "345",
    "346",
    "347",
    "348",
    "349",
    "354",
    "364",
    "374",
    "384",
    "394",
    "400",
    "401",
    "402",
    "403",
    "404",
    "405",
    "406",
    "407",
    "408",
    "409",
    "410",
    "411",
    "412",
    "413",
    "414",
    "415",
    "416",
    "417",
    "418",
    "419",
    "420",
    "421",
    "422",
    "423",
    "424",
    "425",
    "426",
    "427",
    "428",
    "429",
    "430",
    "431",
    "432",
    "433",
    "434",
    "435",
    "436",
    "437",
    "438",
    "439",
    "440",
    "441",
    "442",
    "443",
    "444",
    "445",
    "446",
    "447",
    "448",
    "449",
    "450",
    "451",
    "452",
    "453",
    "454",
    "455",
    "456",
    "457",
    "458",
    "459",
    "460",
    "461",
    "462",
    "463",
    "464",
    "465",
    "466",
    "467",
    "468",
    "469",
    "470",
    "471",
    "472",
    "473",
    "474",
    "475",
    "476",
    "477",
    "478",
    "479",
    "480",
    "481",
    "482",
    "483",
    "484",
    "485",
    "486",
    "487",
    "488",
    "489",
    "490",
    "491",
    "492",
    "493",
    "494",
    "495",
    "496",
    "497",
    "498",
    "499",
    "504",
    "514",
    "524",
    "534",
    "540",
    "541",
    "542",
    "543",
    "544",
    "545",
    "546",
    "547",
    "548",
    "549",
    "554",
    "564",
    "574",
    "584",
    "594",
    "604",
    "614",
    "624",
    "634",
    "640",
    "641",
    "642",
    "643",
    "644",
    "645",
    "646",
    "647",
    "648",
    "649",
    "654",
    "664",
    "674",
    "684",
    "694",
    "704",
    "714",
    "724",
    "734",
    "740",
    "741",
    "742",
    "743",
    "744",
    "745",
    "746",
    "747",
    "748",
    "749",
    "754",
    "764",
    "774",
    "784",
    "794",
    "804",
    "814",
    "824",
    "834",
    "840",
    "841",
    "842",
    "843",
    "844",
    "845",
    "846",
    "847",
    "848",
    "849",
    "854",
    "864",
    "874",
    "884",
    "894",
    "904",
    "914",
    "924",
    "934",
    "940",
    "941",
    "942",
    "943",
    "944",
    "945",
    "946",
    "947",
    "948",
    "949",
    "954",
    "964",
    "974",
    "984",
    "994"
  ],
  "5": [
    "005",
    "015",
    "025",
    "035",
    "045",
    "050",
    "051",
    "052",
    "053",
    "054",
    "055",
    "056",
    "057",
    "058",
    "059",
    "065",
    "075",
    "085",
    "095",
    "105",
    "115",
    "125",
    "135",
    "145",
    "150",
    "151",
    "152",
    "153",
    "154",
    "155",
    "156",
    "157",
    "158",
    "159",
    "165",
    "175",
    "185",
    "195",
    "205",
    "215",
    "225",
    "235",
    "245",
    "250",
    "251",
    "252",
    "253",
    "254",
    "255",
    "256",
    "257",
    "258",
    "259",
    "265",
    "275",
    "285",
    "295",
    "305",
    "315",
    "325",
    "335",
    "345",
    "350",
    "351",
    "352",
    "353",
    "354",
    "355",
    "356",
    "357",
    "358",
    "359",
    "365",
    "375",
    "385",
    "395",
    "405",
    "415",
    "425",
    "435",
    "445",
    "450",
    "451",
    "452",
    "453",
    "454",
    "455",
    "456",
    "457",
    "458",
    "459",
    "465",
    "475",
    "485",
    "495",
    "500",
    "501",
    "502",
    "503",
    "504",
    "505",
    "506",
    "507",
    "508",
    "509",
    "510",
    "511",
    "512",
    "513",
    "514",
    "515",
    "516",
    "517",
    "518",
    "519",
    "520",
    "521",
    "522",
    "523",
    "524",
    "525",
    "526",
    "527",
    "528",
    "529",
    "530",
    "531",
    "532",
    "533",
    "534",
    "535",
    "536",
    "537",
    "538",
    "539",
    "540",
    "541",
    "542",
    "543",
    "544",
    "545",
    "546",
    "547",
    "548",
    "549",
    "550",
    "551",
    "552",
    "553",
    "554",
    "555",
    "556",
    "557",
    "558",
    "559",
    "560",
    "561",
    "562",
    "563",
    "564",
    "565",
    "566",
    "567",
    "568",
    "569",
    "570",
    "571",
    "572",
    "573",
    "574",
    "575",
    "576",
    "577",
    "578",
    "579",
    "580",
    "581",
    "582",
    "583",
    "584",
    "585",
    "586",
    "587",
    "588",
    "589",
    "590",
    "591",
    "592",
    "593",
    "594",
    "595",
    "596",
    "597",
    "598",
    "599",
    "605",
    "615",
    "625",
    "635",
    "645",
    "650",
    "651",
    "652",
    "653",
    "654",
    "655",
    "656",
    "657",
    "658",
    "659",
    "665",
    "675",
    "685",
    "695",
    "705",
    "715",
    "725",
    "735",
    "745",
    "750",
    "751",
    "752",
    "753",
    "754",
    "755",
    "756",
    "757",
    "758",
    "759",
    "765",
    "775",
    "785",
    "795",
    "805",
    "815",
    "825",
    "835",
    "845",
    "850",
    "851",
    "852",
    "853",
    "854",
    "855",
    "856",
    "857",
    "858",
    "859",
    "865",
    "875",
    "885",
    "895",
    "905",
    "915",
    "925",
    "935",
    "945",
    "950",
    "951",
    "952",
    "953",
    "954",
    "955",
    "956",
    "957",
    "958",
    "959",
    "965",
    "975",
    "985",
    "995"
  ],
  "6": [
    "006",
    "016",
    "026",
    "036",
    "046",
    "056",
    "060",
    "061",
    "062",
    "063",
    "064",
    "065",
    "066",
    "067",
    "068",
    "069",
    "076",
    "086",
    "096",
    "106",
    "116",
    "126",
    "136",
    "146",
    "156",
    "160",
    "161",
    "162",
    "163",
    "164",
    "165",
    "166",
    "167",
    "168",
    "169",
    "176",
    "186",
    "196",
    "206",
    "216",
    "226",
    "236",
    "246",
    "256",
    "260",
    "261",
    "262",
    "263",
    "264",
    "265",
    "266",
    "267",
    "268",
    "269",
    "276",
    "286",
    "296",
    "306",
    "316",
    "326",
    "336",
    "346",
    "356",
    "360",
    "361",
    "362",
    "363",
    "364",
    "365",
    "366",
    "367",
    "368",
    "369",
    "376",
    "386",
    "396",
    "406",
    "416",
    "426",
    "436",
    "446",
    "456",
    "460",
    "461",
    "462",
    "463",
    "464",
    "465",
    "466",
    "467",
    "468",
    "469",
    "476",
    "486",
    "496",
    "506",
    "516",
    "526",
    "536",
    "546",
    "556",
    "560",
    "561",
    "562",
    "563",
    "564",
    "565",
    "566",
    "567",
    "568",
    "569",
    "576",
    "586",
    "596",
    "600",
    "601",
    "602",
    "603",
    "604",
    "605",
    "606",
    "607",
    "608",
    "609",
    "610",
    "611",
    "612",
    "613",
    "614",
    "615",
    "616",
    "617",
    "618",
    "619",
    "620",
    "621",
    "622",
    "623",
    "624",
    "625",
    "626",
    "627",
    "628",
    "629",
    "630",
    "631",
    "632",
    "633",
    "634",
    "635",
    "636",
    "637",
    "638",
    "639",
    "640",
    "641",
    "642",
    "643",
    "644",
    "645",
    "646",
    "647",
    "648",
    "649",
    "650",
    "651",
    "652",
    "653",
    "654",
    "655",
    "656",
    "657",
    "658",
    "659",
    "660",
    "661",
    "662",
    "663",
    "664",
    "665",
    "666",
    "667",
    "668",
    "669",
    "670",
    "671",
    "672",
    "673",
    "674",
    "675",
    "676",
    "677",
    "678",
    "679",
    "680",
    "681",
    "682",
    "683",
    "684",
    "685",
    "686",
    "687",
    "688",
    "689",
    "690",
    "691",
    "692",
    "693",
    "694",
    "695",
    "696",
    "697",
    "698",
    "699",
    "706",
    "716",
    "726",
    "736",
    "746",
    "756",
    "760",
    "761",
    "762",
    "763",
    "764",
    "765",
    "766",
    "767",
    "768",
    "769",
    "776",
    "786",
    "796",
    "806",
    "816",
    "826",
    "836",
    "846",
    "856",
    "860",
    "861",
    "862",
    "863",
    "864",
    "865",
    "866",
    "867",
    "868",
    "869",
    "876",
    "886",
    "896",
    "906",
    "916",
    "926",
    "936",
    "946",
    "956",
    "960",
    "961",
    "962",
    "963",
    "964",
    "965",
    "966",
    "967",
    "968",
    "969",
    "976",
    "986",
    "996"
  ],
  "7": [
    "007",
    "017",
    "027",
    "037",
    "047",
    "057",
    "067",
    "070",
    "071",
    "072",
    "073",
    "074",
    "075",
    "076",
    "077",
    "078",
    "079",
    "087",
    "097",
    "107",
    "117",
    "127",
    "137",
    "147",
    "157",
    "167",
    "170",
    "171",
    "172",
    "173",
    "174",
    "175",
    "176",
    "177",
    "178",
    "179",
    "187",
    "197",
    "207",
    "217",
    "227",
    "237",
    "247",
    "257",
    "267",
    "270",
    "271",
    "272",
    "273",
    "274",
    "275",
    "276",
    "277",
    "278",
    "279",
    "287",
    "297",
    "307",
    "317",
    "327",
    "337",
    "347",
    "357",
    "367",
    "370",
    "371",
    "372",
    "373",
    "374",
    "375",
    "376",
    "377",
    "378",
    "379",
    "387",
    "397",
    "407",
    "417",
    "427",
    "437",
    "447",
    "457",
    "467",
    "470",
    "471",
    "472",
    "473",
    "474",
    "475",
    "476",
    "477",
    "478",
    "479",
    "487",
    "497",
    "507",
    "517",
    "527",
    "537",
    "547",
    "557",
    "567",
    "570",
    "571",
    "572",
    "573",
    "574",
    "575",
    "576",
    "577",
    "578",
    "579",
    "587",
    "597",
    "607",
    "617",
    "627",
    "637",
    "647",
    "657",
    "667",
    "670",
    "671",
    "672",
    "673",
    "674",
    "675",
    "676",
    "677",
    "678",
    "679",
    "687",
    "697",
    "700",
    "701",
    "702",
    "703",
    "704",
    "705",
    "706",
    "707",
    "708",
    "709",
    "710",
    "711",
    "712",
    "713",
    "714",
    "715",
    "716",
    "717",
    "718",
    "719",
    "720",
    "721",
    "722",
    "723",
    "724",
    "725",
    "726",
    "727",
    "728",
    "729",
    "730",
    "731",
    "732",
    "733",
    "734",
    "735",
    "736",
    "737",
    "738",
    "739",
    "740",
    "741",
    "742",
    "743",
    "744",
    "745",
    "746",
    "747",
    "748",
    "749",
    "750",
    "751",
    "752",
    "753",
    "754",
    "755",
    "756",
    "757",
    "758",
    "759",
    "760",
    "761",
    "762",
    "763",
    "764",
    "765",
    "766",
    "767",
    "768",
    "769",
    "770",
    "771",
    "772",
    "773",
    "774",
    "775",
    "776",
    "777",
    "778",
    "779",
    "780",
    "781",
    "782",
    "783",
    "784",
    "785",
    "786",
    "787",
    "788",
    "789",
    "790",
    "791",
    "792",
    "793",
    "794",
    "795",
    "796",
    "797",
    "798",
    "799",
    "807",
    "817",
    "827",
    "837",
    "847",
    "857",
    "867",
    "870",
    "871",
    "872",
    "873",
    "874",
    "875",
    "876",
    "877",
    "878",
    "879",
    "887",
    "897",
    "907",
    "917",
    "927",
    "937",
    "947",
    "957",
    "967",
    "970",
    "971",
    "972",
    "973",
    "974",
    "975",
    "976",
    "977",
    "978",
    "979",
    "987",
    "997"
  ],
  "8": [
    "008",
    "018",
    "028",
    "038",
    "048",
    "058",
    "068",
    "078",
    "080",
    "081",
    "082",
    "083",
    "084",
    "085",
    "086",
    "087",
    "088",
    "089",
    "098",
    "108",
    "118",
    "128",
    "138",
    "148",
    "158",
    "168",
    "178",
    "180",
    "181",
    "182",
    "183",
    "184",
    "185",
    "186",
    "187",
    "188",
    "189",
    "198",
    "208",
    "218",
    "228",
    "238",
    "248",
    "258",
    "268",
    "278",
    "280",
    "281",
    "282",
    "283",
    "284",
    "285",
    "286",
    "287",
    "288",
    "289",
    "298",
    "308",
    "318",
    "328",
    "338",
    "348",
    "358",
    "368",
    "378",
    "380",
    "381",
    "382",
    "383",
    "384",
    "385",
    "386",
    "387",
    "388",
    "389",
    "398",
    "408",
    "418",
    "428",
    "438",
    "448",
    "458",
    "468",
    "478",
    "480",
    "481",
    "482",
    "483",
    "484",
    "485",
    "486",
    "487",
    "488",
    "489",
    "498",
    "508",
    "518",
    "528",
    "538",
    "548",
    "558",
    "568",
    "578",
    "580",
    "581",
    "582",
    "583",
    "584",
    "585",
    "586",
    "587",
    "588",
    "589",
    "598",
    "608",
    "618",
    "628",
    "638",
    "648",
    "658",
    "668",
    "678",
    "680",
    "681",
    "682",
    "683",
    "684",
    "685",
    "686",
    "687",
    "688",
    "689",
    "698",
    "708",
    "718",
    "728",
    "738",
    "748",
    "758",
    "768",
    "778",
    "780",
    "781",
    "782",
    "783",
    "784",
    "785",
    "786",
    "787",
    "788",
    "789",
    "798",
    "800",
    "801",
    "802",
    "803",
    "804",
    "805",
    "806",
    "807",
    "808",
    "809",
    "810",
    "811",
    "812",
    "813",
    "814",
    "815",
    "816",
    "817",
    "818",
    "819",
    "820",
    "821",
    "822",
    "823",
    "824",
    "825",
    "826",
    "827",
    "828",
    "829",
    "830",
    "831",
    "832",
    "833",
    "834",
    "835",
    "836",
    "837",
    "838",
    "839",
    "840",
    "841",
    "842",
    "843",
    "844",
    "845",
    "846",
    "847",
    "848",
    "849",
    "850",
    "851",
    "852",
    "853",
    "854",
    "855",
    "856",
    "857",
    "858",
    "859",
    "860",
    "861",
    "862",
    "863",
    "864",
    "865",
    "866",
    "867",
    "868",
    "869",
    "870",
    "871",
    "872",
    "873",
    "874",
    "875",
    "876",
    "877",
    "878",
    "879",
    "880",
    "881",
    "882",
    "883",
    "884",
    "885",
    "886",
    "887",
    "888",
    "889",
    "890",
    "891",
    "892",
    "893",
    "894",
    "895",
    "896",
    "897",
    "898",
    "899",
    "908",
    "918",
    "928",
    "938",
    "948",
    "958",
    "968",
    "978",
    "980",
    "981",
    "982",
    "983",
    "984",
    "985",
    "986",
    "987",
    "988",
    "989",
    "998"
  ],
  "9": [
    "009",
    "019",
    "029",
    "039",
    "049",
    "059",
    "069",
    "079",
    "089",
    "090",
    "091",
    "092",
    "093",
    "094",
    "095",
    "096",
    "097",
    "098",
    "099",
    "109",
    "119",
    "129",
    "139",
    "149",
    "159",
    "169",
    "179",
    "189",
    "190",
    "191",
    "192",
    "193",
    "194",
    "195",
    "196",
    "197",
    "198",
    "199",
    "209",
    "219",
    "229",
    "239",
    "249",
    "259",
    "269",
    "279",
    "289",
    "290",
    "291",
    "292",
    "293",
    "294",
    "295",
    "296",
    "297",
    "298",
    "299",
    "309",
    "319",
    "329",
    "339",
    "349",
    "359",
    "369",
    "379",
    "389",
    "390",
    "391",
    "392",
    "393",
    "394",
    "395",
    "396",
    "397",
    "398",
    "399",
    "409",
    "419",
    "429",
    "439",
    "449",
    "459",
    "469",
    "479",
    "489",
    "490",
    "491",
    "492",
    "493",
    "494",
    "495",
    "496",
    "497",
    "498",
    "499",
    "509",
    "519",
    "529",
    "539",
    "549",
    "559",
    "569",
    "579",
    "589",
    "590",
    "591",
    "592",
    "593",
    "594",
    "595",
    "596",
    "597",
    "598",
    "599",
    "609",
    "619",
    "629",
    "639",
    "649",
    "659",
    "669",
    "679",
    "689",
    "690",
    "691",
    "692",
    "693",
    "694",
    "695",
    "696",
    "697",
    "698",
    "699",
    "709",
    "719",
    "729",
    "739",
    "749",
    "759",
    "769",
    "779",
    "789",
    "790",
    "791",
    "792",
    "793",
    "794",
    "795",
    "796",
    "797",
    "798",
    "799",
    "809",
    "819",
    "829",
    "839",
    "849",
    "859",
    "869",
    "879",
    "889",
    "890",
    "891",
    "892",
    "893",
    "894",
    "895",
    "896",
    "897",
    "898",
    "899",
    "900",
    "901",
    "902",
    "903",
    "904",
    "905",
    "906",
    "907",
    "908",
    "909",
    "910",
    "911",
    "912",
    "913",
    "914",
    "915",
    "916",
    "917",
    "918",
    "919",
    "920",
    "921",
    "922",
    "923",
    "924",
    "925",
    "926",
    "927",
    "928",
    "929",
    "930",
    "931",
    "932",
    "933",
    "934",
    "935",
    "936",
    "937",
    "938",
    "939",
    "940",
    "941",
    "942",
    "943",
    "944",
    "945",
    "946",
    "947",
    "948",
    "949",
    "950",
    "951",
    "952",
    "953",
    "954",
    "955",
    "956",
    "957",
    "958",
    "959",
    "960",
    "961",
    "962",
    "963",
    "964",
    "965",
    "966",
    "967",
    "968",
    "969",
    "970",
    "971",
    "972",
    "973",
    "974",
    "975",
    "976",
    "977",
    "978",
    "979",
    "980",
    "981",
    "982",
    "983",
    "984",
    "985",
    "986",
    "987",
    "988",
    "989",
    "990",
    "991",
    "992",
    "993",
    "994",
    "995",
    "996",
    "997",
    "998",
    "999"
  ]
};

const MatkaDeclareResults = () => {
  const { user } = useAuth();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  
  const [markets, setMarkets] = useState([]);
  const [results, setResults] = useState([]);
  const [statistics, setStatistics] = useState({});
  const [loading, setLoading] = useState(false);
  const [loadingMarkets, setLoadingMarkets] = useState(false);
  const [declareDialogOpen, setDeclareDialogOpen] = useState(false);
  const [tabValue, setTabValue] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [activeStep, setActiveStep] = useState(0);
  
  const [declareForm, setDeclareForm] = useState({
    marketId: '',
    resultDate: new Date().toISOString().split('T')[0],
    openPanna: '',
    closePanna: '',
    resultType: 'both'
  });

  // State for panna suggestions
  const [openPannaSuggestions, setOpenPannaSuggestions] = useState([]);
  const [closePannaSuggestions, setClosePannaSuggestions] = useState([]);
  const [openPannaFirstDigit, setOpenPannaFirstDigit] = useState('');
  const [closePannaFirstDigit, setClosePannaFirstDigit] = useState('');

  // State for existing results
  const [selectedMarketResult, setSelectedMarketResult] = useState(null);
  const [isOpenPannaDisabled, setIsOpenPannaDisabled] = useState(false);
  const [isClosePannaDisabled, setIsClosePannaDisabled] = useState(false);

  const [filters, setFilters] = useState({
    marketId: '',
    dateFrom: '',
    dateTo: '',
  });

  // Preview state
  const [previewDialogOpen, setPreviewDialogOpen] = useState(false);
  const [previewLoading, setPreviewLoading] = useState(false);
  const [previewData, setPreviewData] = useState(null);
  const [previewExpanded, setPreviewExpanded] = useState({});

  // Function to get suggestions based on first digit
  const getSuggestionsForDigit = (digit) => {
    if (digit === '' || isNaN(digit) || digit < 0 || digit > 9) {
      return [];
    }
    return fullSangamPanna[digit.toString()] || [];
  };

  // Custom filter function to prioritize exact matches
  const filterAndSortSuggestions = (options, inputValue) => {
    if (!inputValue || inputValue.length === 0) {
      return options;
    }

    // Pad input value with zeros to make it 3 digits for comparison
    const paddedInput = inputValue.padStart(3, '0');
    
    // Sort options: exact match first, then others
    return [...options].sort((a, b) => {
      const isAExact = a === paddedInput;
      const isBExact = b === paddedInput;
      
      if (isAExact && !isBExact) return -1; // a comes first
      if (!isAExact && isBExact) return 1;  // b comes first
      
      // If both are exact or both are not, maintain original order
      return 0;
    });
  };

  // Handle open panna input change
  const handleOpenPannaChange = (event, newValue) => {
    const value = newValue || '';
    
    // Update the form value
    setDeclareForm({ ...declareForm, openPanna: value });
    
    // If it's a manual input (typing), handle first digit detection
    if (typeof value === 'string' && value.length > 0) {
      const firstDigit = value[0];
      if (firstDigit !== openPannaFirstDigit) {
        setOpenPannaFirstDigit(firstDigit);
        setOpenPannaSuggestions(getSuggestionsForDigit(firstDigit));
      }
    } else if (value.length === 0) {
      setOpenPannaFirstDigit('');
      setOpenPannaSuggestions([]);
    }
  };

  // Handle close panna input change
  const handleClosePannaChange = (event, newValue) => {
    const value = newValue || '';
    
    // Update the form value
    setDeclareForm({ ...declareForm, closePanna: value });
    
    // If it's a manual input (typing), handle first digit detection
    if (typeof value === 'string' && value.length > 0) {
      const firstDigit = value[0];
      if (firstDigit !== closePannaFirstDigit) {
        setClosePannaFirstDigit(firstDigit);
        setClosePannaSuggestions(getSuggestionsForDigit(firstDigit));
      }
    } else if (value.length === 0) {
      setClosePannaFirstDigit('');
      setClosePannaSuggestions([]);
    }
  };

  // Handle input text change for autocomplete
  const handleOpenPannaInputChange = (event, newValue) => {
    if (newValue.length > 0) {
      const firstDigit = newValue[0];
      if (firstDigit !== openPannaFirstDigit) {
        setOpenPannaFirstDigit(firstDigit);
        setOpenPannaSuggestions(getSuggestionsForDigit(firstDigit));
      }
    } else {
      setOpenPannaFirstDigit('');
      setOpenPannaSuggestions([]);
    }
  };

  const handleClosePannaInputChange = (event, newValue) => {
    if (newValue.length > 0) {
      const firstDigit = newValue[0];
      if (firstDigit !== closePannaFirstDigit) {
        setClosePannaFirstDigit(firstDigit);
        setClosePannaSuggestions(getSuggestionsForDigit(firstDigit));
      }
    } else {
      setClosePannaFirstDigit('');
      setClosePannaSuggestions([]);
    }
  };

  // Handle market selection and check for existing results
  const handleMarketSelection = (marketId) => {
    const selectedMarket = markets.find(m => m.id == marketId);
    
    setDeclareForm(prev => ({ ...prev, marketId, openPanna: '', closePanna: '' }));
    setSelectedMarketResult(null);
    setIsOpenPannaDisabled(false);
    setIsClosePannaDisabled(false);
    
    // Check if there's a date_result for the selected market
    if (selectedMarket?.date_result) {
      const existingResult = selectedMarket.date_result;
      setSelectedMarketResult(existingResult);
      
      // Check if open_panna exists and disable field
      if (existingResult.open_panna) {
        setIsOpenPannaDisabled(true);
        setDeclareForm(prev => ({ ...prev, openPanna: existingResult.open_panna.toString() }));
      }
      
      // Check if close_panna exists and disable field
      if (existingResult.close_panna) {
        setIsClosePannaDisabled(true);
        setDeclareForm(prev => ({ ...prev, closePanna: existingResult.close_panna.toString() }));
      }
    }
  };

  useEffect(() => {
    fetchMarkets(declareForm.resultDate);
    fetchResults();
    fetchStatistics();
  }, [filters, page, rowsPerPage]);

  // Separate useEffect to fetch markets when declare form date changes
  useEffect(() => {
    if (declareDialogOpen) {
      fetchMarkets(declareForm.resultDate);
    }
  }, [declareForm.resultDate, declareDialogOpen]);

  const fetchMarkets = async (date = null) => {
    try {
      setLoadingMarkets(true);
      const targetDate = date || declareForm.resultDate;
      const response = await marketAPI.getMarketsResults(targetDate);
      if (response.data.success) {
        setMarkets(response.data.markets?.filter(m => m.market_status === 'active') || []);
      }
    } catch (err) {
      console.error('Error fetching markets:', err);
      toast.error('Failed to fetch markets for selected date');
    } finally {
      setLoadingMarkets(false);
    }
  };

  const fetchResults = async () => {
    try {
      const params = {
        ...filters,
        limit: rowsPerPage,
        offset: page * rowsPerPage,
      };
      
      Object.keys(params).forEach(key => {
        if (!params[key]) delete params[key];
      });

      const response = await matkaAPI.getMatkaResults(params);
      if (response.data.success) {
        setResults(response.data.results || []);
      }
    } catch (err) {
      console.error('Error fetching results:', err);
      toast.error('Failed to fetch results');
    }
  };

  const fetchStatistics = async () => {
    try {
      const params = { ...filters };
      Object.keys(params).forEach(key => {
        if (!params[key]) delete params[key];
      });

      const response = await matkaAPI.getMatkaStatistics(params);
      if (response.data.success) {
        setStatistics(response.data.statistics || {});
      }
    } catch (err) {
      console.error('Error fetching statistics:', err);
    }
  };

  // Validation function for panna numbers
  const validatePanna = (panna, pannaType) => {
    if (!panna) return true; // Empty is allowed
    
    // Check if it's a valid number (1-3 digits)
    if (!/^\d{1,3}$/.test(panna)) {
      return `${pannaType} must be a valid number`;
    }
    
    // Pad with leading zeros to make it 3 digits for display
    const paddedPanna = panna.padStart(3, '0');
    const firstDigit = paddedPanna[0];
    
    // Check if the panna is in the valid list for the first digit
    const validPannas = fullSangamPanna[firstDigit] || [];
    if (!validPannas.includes(paddedPanna)) {
      return `${pannaType} ${paddedPanna} is not valid for digit ${firstDigit}. Please select from suggested numbers.`;
    }
    
    return null; // Valid
  };

  const handleDeclareResult = async () => {
    try {
      if (!declareForm.marketId || !declareForm.resultDate) {
        toast.error('Market and date are required');
        return;
      }

      // Check if there's at least one new panna to declare
      const hasNewOpenPanna = declareForm.openPanna && !isOpenPannaDisabled;
      const hasNewClosePanna = declareForm.closePanna && !isClosePannaDisabled;
      const hasExistingOpenPanna = isOpenPannaDisabled && declareForm.openPanna;
      const hasExistingClosePanna = isClosePannaDisabled && declareForm.closePanna;

      if (!hasNewOpenPanna && !hasNewClosePanna && !hasExistingOpenPanna && !hasExistingClosePanna) {
        toast.error('At least one panna (open or close) is required');
        return;
      }

      if (!hasNewOpenPanna && !hasNewClosePanna) {
        toast.error('No new results to declare. All pannas are already declared for this date.');
        return;
      }

      // Validate only the new panna numbers that are being entered
      if (hasNewOpenPanna) {
        const openValidation = validatePanna(declareForm.openPanna, 'Open Panna');
        if (openValidation) {
          toast.error(openValidation);
          return;
        }
      }

      if (hasNewClosePanna) {
        const closeValidation = validatePanna(declareForm.closePanna, 'Close Panna');
        if (closeValidation) {
          toast.error(closeValidation);
          return;
        }
      }

      setLoading(true);
      const payload = {
        result_date: declareForm.resultDate,
        result_type: declareForm.resultType
      };

      // Only send new panna values that are being declared (not already existing ones)
      // Send as string with leading zeros preserved (e.g., "001", "002")
      if (hasNewOpenPanna) {
        payload.open_panna = declareForm.openPanna.toString().padStart(3, '0');
      }

      if (hasNewClosePanna) {
        payload.close_panna = declareForm.closePanna.toString().padStart(3, '0');
      }

      const response = await matkaAPI.declareMatkaResult(declareForm.marketId, payload);
      
      if (response.data.success) {
        toast.success('Result declared successfully and bets processed!');
        setDeclareDialogOpen(false);
        setActiveStep(0);
        fetchResults();
        fetchStatistics();
        resetDeclareForm();
      } else {
        toast.error(response.data.message || 'Failed to declare result');
      }
    } catch (err) {
      console.error('Error declaring result:', err);
      toast.error(err.response?.data?.message || 'Failed to declare result');
    } finally {
      setLoading(false);
    }
  };

  // Handle preview winners
  const handlePreviewWinners = async () => {
    try {
      if (!declareForm.marketId || !declareForm.resultDate) {
        toast.error('Please select market and date first');
        return;
      }

      // Check if there's at least one new panna to preview
      const hasNewOpenPanna = declareForm.openPanna && !isOpenPannaDisabled;
      const hasNewClosePanna = declareForm.closePanna && !isClosePannaDisabled;

      if (!hasNewOpenPanna && !hasNewClosePanna) {
        toast.error('Please enter at least one new panna value to preview');
        return;
      }

      // Validate panna numbers
      if (hasNewOpenPanna) {
        const openValidation = validatePanna(declareForm.openPanna, 'Open Panna');
        if (openValidation) {
          toast.error(openValidation);
          return;
        }
      }

      if (hasNewClosePanna) {
        const closeValidation = validatePanna(declareForm.closePanna, 'Close Panna');
        if (closeValidation) {
          toast.error(closeValidation);
          return;
        }
      }

      setPreviewLoading(true);
      
      const payload = {
        result_date: declareForm.resultDate,
      };

      if (hasNewOpenPanna) {
        payload.open_panna = declareForm.openPanna.toString().padStart(3, '0');
      }

      if (hasNewClosePanna) {
        payload.close_panna = declareForm.closePanna.toString().padStart(3, '0');
      }

      const response = await matkaAPI.previewMatkaWinners(declareForm.marketId, payload);
      
      if (response.data.success) {
        setPreviewData(response.data.preview);
        setPreviewDialogOpen(true);
        setPreviewExpanded({});
      } else {
        toast.error(response.data.message || 'Failed to preview winners');
      }
    } catch (err) {
      console.error('Error previewing winners:', err);
      toast.error(err.response?.data?.message || 'Failed to preview winners');
    } finally {
      setPreviewLoading(false);
    }
  };

  const resetDeclareForm = () => {
    setDeclareForm({
      marketId: '',
      resultDate: new Date().toISOString().split('T')[0],
      openPanna: '',
      closePanna: '',
      resultType: 'both'
    });
    
    // Reset suggestion states
    setOpenPannaSuggestions([]);
    setClosePannaSuggestions([]);
    setOpenPannaFirstDigit('');
    setClosePannaFirstDigit('');
    
    // Reset existing results states
    setSelectedMarketResult(null);
    setIsOpenPannaDisabled(false);
    setIsClosePannaDisabled(false);
  };

  const handleDeleteResult = async (resultId) => {
    if (!window.confirm('Are you sure you want to delete this result? This will reverse all winning amounts and reset all bets to pending status.')) {
      return;
    }

    try {
      setLoading(true);
      const response = await matkaAPI.deleteMatkaResult(resultId);
      
      if (response.data.success) {
        toast.success(response.data.message || 'Result deleted successfully');
        fetchResults();
        fetchStatistics();
      } else {
        toast.error(response.data.message || 'Failed to delete result');
      }
    } catch (err) {
      console.error('Error deleting result:', err);
      toast.error(err.response?.data?.message || 'Failed to delete result');
    } finally {
      setLoading(false);
    }
  };

  const handleNext = () => {
    setActiveStep((prevStep) => prevStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevStep) => prevStep - 1);
  };

  const calculateDigit = (panna) => {
    if (!panna) return null;
    const pannaStr = panna.toString().padStart(3, '0');
    const sum = pannaStr.split('').reduce((acc, digit) => acc + parseInt(digit), 0);
    return sum % 10;
  };

  const calculateJodi = (openSingle, closeSingle) => {
    if (openSingle !== null && closeSingle !== null) {
      return `${openSingle}${closeSingle}`;
    }
    return null;
  };

  const formatCurrency = (amount) => {
    return `₹${parseFloat(amount || 0).toFixed(2)}`;
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString();
  };

  const formatDateTime = (dateString) => {
    return new Date(dateString).toLocaleString();
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const steps = [
    {
      label: 'Select Market & Date',
      content: (
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Market"
              select
              value={declareForm.marketId}
              onChange={(e) => handleMarketSelection(e.target.value)}
              disabled={loadingMarkets}
              required
              helperText={loadingMarkets ? "Loading markets for selected date..." : ""}
              SelectProps={{
                displayEmpty: true,
                renderValue: (selected) => {
                  if (!selected) {
                    return <em style={{ color: '#999', fontStyle: 'normal' }}>Select Market</em>;
                  }
                  const market = markets.find(m => m.id === selected);
                  if (!market) return 'Select Market';
                  return market.market_name + 
                    (market.date_result && 
                     (market.date_result.open_panna || market.date_result.close_panna) ? 
                     " (Partial Result Exists)" : "");
                }
              }}
              InputLabelProps={{
                shrink: true
              }}
            >
              <MenuItem value="" disabled>
                <em>Select Market</em>
              </MenuItem>
              {markets.map((market) => (
                <MenuItem key={market.id} value={market.id}>
                  {market.market_name}
                  {market.date_result && 
                   (market.date_result.open_panna || market.date_result.close_panna) && 
                   " (Partial Result Exists)"}
                </MenuItem>
              ))}
              {markets.length === 0 && !loadingMarkets && (
                <MenuItem disabled>No active markets found for this date</MenuItem>
              )}
            </TextField>
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Result Date"
              type="date"
              value={declareForm.resultDate}
              onChange={(e) => {
                const newDate = e.target.value;
                setDeclareForm({ ...declareForm, resultDate: newDate });
                // Reset market selection when date changes so user needs to reselect
                if (declareForm.marketId) {
                  setDeclareForm(prev => ({ ...prev, marketId: '', openPanna: '', closePanna: '' }));
                  setSelectedMarketResult(null);
                  setIsOpenPannaDisabled(false);
                  setIsClosePannaDisabled(false);
                }
              }}
              InputLabelProps={{ shrink: true }}
              required
            />
          </Grid>
        </Grid>
      )
    },
    {
      label: 'Enter Results',
      content: (
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Autocomplete
              freeSolo
              fullWidth
              disabled={isOpenPannaDisabled}
              options={openPannaSuggestions}
              value={declareForm.openPanna}
              onChange={handleOpenPannaChange}
              onInputChange={handleOpenPannaInputChange}
              filterOptions={(options, state) => filterAndSortSuggestions(options, state.inputValue)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={isOpenPannaDisabled ? "Open Panna (Already Declared)" : "Open Panna (3 digits)"}
                  helperText={
                    isOpenPannaDisabled 
                      ? `Result already declared: ${declareForm.openPanna} | Open Single: ${calculateDigit(declareForm.openPanna)}`
                      : openPannaFirstDigit 
                        ? `Showing ${openPannaSuggestions.length} options for digit ${openPannaFirstDigit}${declareForm.openPanna ? ` | Open Single: ${calculateDigit(declareForm.openPanna)}` : ''}` 
                        : 'Type first digit to see suggestions'
                  }
                  inputProps={{
                    ...params.inputProps,
                    maxLength: 3,
                    pattern: '[0-9]{1,3}',
                  }}
                />
              )}
              isOptionEqualToValue={(option, value) => option === value}
              noOptionsText={openPannaFirstDigit ? `No options for digit ${openPannaFirstDigit}` : 'Type first digit to see options'}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Autocomplete
              freeSolo
              fullWidth
              disabled={isClosePannaDisabled}
              options={closePannaSuggestions}
              value={declareForm.closePanna}
              onChange={handleClosePannaChange}
              onInputChange={handleClosePannaInputChange}
              filterOptions={(options, state) => filterAndSortSuggestions(options, state.inputValue)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={isClosePannaDisabled ? "Close Panna (Already Declared)" : "Close Panna (3 digits)"}
                  helperText={
                    isClosePannaDisabled 
                      ? `Result already declared: ${declareForm.closePanna} | Close Single: ${calculateDigit(declareForm.closePanna)}`
                      : closePannaFirstDigit 
                        ? `Showing ${closePannaSuggestions.length} options for digit ${closePannaFirstDigit}${declareForm.closePanna ? ` | Close Single: ${calculateDigit(declareForm.closePanna)}` : ''}` 
                        : 'Type first digit to see suggestions'
                  }
                  inputProps={{
                    ...params.inputProps,
                    maxLength: 3,
                    pattern: '[0-9]{1,3}',
                  }}
                />
              )}
              isOptionEqualToValue={(option, value) => option === value}
              noOptionsText={closePannaFirstDigit ? `No options for digit ${closePannaFirstDigit}` : 'Type first digit to see options'}
            />
          </Grid>
          {/* Show existing results info */}
          {selectedMarketResult && (
            <Grid item xs={12}>
              <Box sx={{ p: 2, bgcolor: 'warning.light', borderRadius: 1, mb: 2 }}>
                <Typography variant="h6" gutterBottom color="warning.dark">
                  Existing Results for Selected Date:
                </Typography>
                <Typography color="warning.dark">
                  {selectedMarketResult.open_panna && `Open Panna: ${selectedMarketResult.open_panna} (Single: ${selectedMarketResult.open_single}) | `}
                  {selectedMarketResult.close_panna && `Close Panna: ${selectedMarketResult.close_panna} (Single: ${selectedMarketResult.close_single}) | `}
                  {selectedMarketResult.jodi && `Jodi: ${selectedMarketResult.jodi}`}
                </Typography>
                <Typography variant="body2" color="warning.dark" sx={{ mt: 1 }}>
                  You can only update the missing result(s).
                </Typography>
              </Box>
            </Grid>
          )}
          
          {declareForm.openPanna && declareForm.closePanna && (
            <Grid item xs={12}>
              <Box sx={{ p: 2, bgcolor: 'primary.light', borderRadius: 1 }}>
                <Typography variant="h6" gutterBottom>
                  Calculated Results:
                </Typography>
                <Typography>
                  Open Single: {calculateDigit(declareForm.openPanna)} | 
                  Close Single: {calculateDigit(declareForm.closePanna)} | 
                  Jodi: {calculateJodi(calculateDigit(declareForm.openPanna), calculateDigit(declareForm.closePanna))}
                </Typography>
              </Box>
            </Grid>
          )}
        </Grid>
      )
    },
    {
      label: 'Confirm & Declare',
      content: (
        <Box>
          <Typography variant="h6" gutterBottom>
            Confirm Result Declaration
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Typography variant="body2" color="textSecondary">Market:</Typography>
              <Typography variant="body1" sx={{ mb: 1 }}>
                {markets.find(m => m.id == declareForm.marketId)?.market_name}
              </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography variant="body2" color="textSecondary">Date:</Typography>
              <Typography variant="body1" sx={{ mb: 1 }}>
                {declareForm.resultDate}
              </Typography>
            </Grid>
            {declareForm.openPanna && (
              <Grid item xs={12} md={6}>
                <Typography variant="body2" color="textSecondary">Open Panna:</Typography>
                <Typography variant="h6" color="primary.main">
                  {declareForm.openPanna} (Single: {calculateDigit(declareForm.openPanna)})
                </Typography>
              </Grid>
            )}
            {declareForm.closePanna && (
              <Grid item xs={12} md={6}>
                <Typography variant="body2" color="textSecondary">Close Panna:</Typography>
                <Typography variant="h6" color="primary.main">
                  {declareForm.closePanna} (Single: {calculateDigit(declareForm.closePanna)})
                </Typography>
              </Grid>
            )}
          </Grid>
        </Box>
      )
    }
  ];

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <Box sx={{ p: 3 }}>
        <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ mb: 3 }}>
          <Typography variant="h4" sx={{ fontWeight: 'bold', display: 'flex', alignItems: 'center' }}>
            <AnnouncementIcon sx={{ mr: 2 }} />
            Matka Results & Statistics
          </Typography>
          {(user?.user_type === 'admin' || user?.user_type === 'owner') && (
            <Button
              variant="contained"
              startIcon={<AnnouncementIcon />}
              onClick={() => setDeclareDialogOpen(true)}
              sx={{
                background: 'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)',
                boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
              }}
            >
              Declare Result
            </Button>
          )}
        </Box>

        {/* Statistics Cards */}
        {statistics.bet_stats && (
          <Grid container spacing={3} sx={{ mb: 4 }}>
            <Grid item xs={12} sm={6} md={3}>
              <motion.div whileHover={{ scale: 1.02 }} style={{ height: '100%' }}>
                <Card sx={{ 
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', 
                  color: 'white',
                  height: '100%',
                  minHeight: 140
                }}>
                  <CardContent sx={{ height: '100%' }}>
                    <Box display="flex" alignItems="center" justifyContent="space-between" height="100%">
                      <Box flex={1}>
                        <Typography variant="h6" sx={{ fontSize: '1rem', mb: 1 }}>Total Bets</Typography>
                        <Typography variant="h4" sx={{ fontWeight: 'bold' }}>
                          {statistics.bet_stats.total_bets || 0}
                        </Typography>
                        <Box sx={{ height: 20 }} /> {/* Spacer for alignment */}
                      </Box>
                      <CasinoIcon sx={{ fontSize: 48, opacity: 0.8 }} />
                    </Box>
                  </CardContent>
                </Card>
              </motion.div>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <motion.div whileHover={{ scale: 1.02 }} style={{ height: '100%' }}>
                <Card sx={{ 
                  background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)', 
                  color: 'white',
                  height: '100%',
                  minHeight: 140
                }}>
                  <CardContent sx={{ height: '100%' }}>
                    <Box display="flex" alignItems="center" justifyContent="space-between" height="100%">
                      <Box flex={1}>
                        <Typography variant="h6" sx={{ fontSize: '1rem', mb: 1 }}>Win Bets</Typography>
                        <Typography variant="h4" sx={{ fontWeight: 'bold' }}>
                          {statistics.bet_stats.win_bets || 0}
                        </Typography>
                        <Typography variant="body2" sx={{ opacity: 0.8, mt: 0.5 }}>
                          {statistics.profit_loss?.win_percentage || 0}%
                        </Typography>
                      </Box>
                      <TrophyIcon sx={{ fontSize: 48, opacity: 0.8 }} />
                    </Box>
                  </CardContent>
                </Card>
              </motion.div>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <motion.div whileHover={{ scale: 1.02 }} style={{ height: '100%' }}>
                <Card sx={{ 
                  background: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)', 
                  color: 'white',
                  height: '100%',
                  minHeight: 140
                }}>
                  <CardContent sx={{ height: '100%' }}>
                    <Box display="flex" alignItems="center" justifyContent="space-between" height="100%">
                      <Box flex={1}>
                        <Typography variant="h6" sx={{ fontSize: '1rem', mb: 1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                          Total Bet Amount
                        </Typography>
                        <Typography variant="h4" sx={{ fontWeight: 'bold', fontSize: '1.5rem' }}>
                          {formatCurrency(statistics.bet_stats.total_bet_amount)}
                        </Typography>
                        <Box sx={{ height: 20 }} /> {/* Spacer for alignment */}
                      </Box>
                      <TrendingUpIcon sx={{ fontSize: 48, opacity: 0.8 }} />
                    </Box>
                  </CardContent>
                </Card>
              </motion.div>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <motion.div whileHover={{ scale: 1.02 }} style={{ height: '100%' }}>
                <Card sx={{ 
                  background: statistics.profit_loss?.total_profit >= 0 
                    ? 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)' 
                    : 'linear-gradient(135deg, #ff6b6b 0%, #ffa500 100%)', 
                  color: 'white',
                  height: '100%',
                  minHeight: 140
                }}>
                  <CardContent sx={{ height: '100%' }}>
                    <Box display="flex" alignItems="center" justifyContent="space-between" height="100%">
                      <Box flex={1}>
                        <Typography variant="h6" sx={{ fontSize: '1rem', mb: 1 }}>
                          {statistics.profit_loss?.total_profit >= 0 ? 'Profit' : 'Loss'}
                        </Typography>
                        <Typography variant="h4" sx={{ fontWeight: 'bold', fontSize: '1.5rem' }}>
                          {formatCurrency(Math.abs(statistics.profit_loss?.total_profit || 0))}
                        </Typography>
                        <Box sx={{ height: 20 }} /> {/* Spacer for alignment */}
                      </Box>
                      <AssessmentIcon sx={{ fontSize: 48, opacity: 0.8 }} />
                    </Box>
                  </CardContent>
                </Card>
              </motion.div>
            </Grid>
          </Grid>
        )}

        <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
          <Tabs value={tabValue} onChange={(e, v) => setTabValue(v)}>
            <Tab label="Recent Results" icon={<HistoryIcon />} />
            <Tab label="Game Type Statistics" icon={<AssessmentIcon />} />
          </Tabs>
        </Box>

        {tabValue === 0 && (
          <Card>
            <CardContent>
              <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
                <Typography variant="h6">Recent Results</Typography>
                <Box display="flex" gap={2}>
                  <TextField
                    size="small"
                    label="Market"
                    select
                    value={filters.marketId}
                    onChange={(e) => setFilters({ ...filters, marketId: e.target.value })}
                    sx={{ minWidth: 150 }}
                  >
                    <MenuItem value="">All Markets</MenuItem>
                    {markets.map((market) => (
                      <MenuItem key={market.id} value={market.id}>
                        {market.market_name}
                      </MenuItem>
                    ))}
                  </TextField>
                  <TextField
                    size="small"
                    label="From Date"
                    type="date"
                    value={filters.dateFrom}
                    onChange={(e) => setFilters({ ...filters, dateFrom: e.target.value })}
                    InputLabelProps={{ shrink: true }}
                  />
                  <TextField
                    size="small"
                    label="To Date"
                    type="date"
                    value={filters.dateTo}
                    onChange={(e) => setFilters({ ...filters, dateTo: e.target.value })}
                    InputLabelProps={{ shrink: true }}
                  />
                </Box>
              </Box>

              <TableContainer component={Paper} sx={{ maxHeight: 500 }}>
                <Table stickyHeader size={isMobile ? "small" : "medium"}>
                  <TableHead>
                    <TableRow>
                      <TableCell>Date</TableCell>
                      <TableCell>Market</TableCell>
                      <TableCell align="center">Open Panna</TableCell>
                      <TableCell align="center">Open Single</TableCell>
                      <TableCell align="center">Close Panna</TableCell>
                      <TableCell align="center">Close Single</TableCell>
                      <TableCell align="center">Jodi</TableCell>
                      <TableCell>Declared By</TableCell>
                      <TableCell>Time</TableCell>
                      {user?.user_type === 'owner' && <TableCell align="center">Actions</TableCell>}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {results.map((result) => (
                      <TableRow key={result.id} hover>
                        <TableCell>
                          <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                            {formatDate(result.result_date)}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant="body2">
                            {result.market?.market_name}
                          </Typography>
                        </TableCell>
                        <TableCell align="center">
                          <Chip 
                            label={result.open_panna || '-'}
                            color="primary"
                            size="small"
                            sx={{ fontFamily: 'monospace', fontWeight: 'bold' }}
                          />
                        </TableCell>
                        <TableCell align="center">
                          <Chip 
                            label={result.open_single !== null ? result.open_single : '-'}
                            color="secondary"
                            size="small"
                            sx={{ fontFamily: 'monospace', fontWeight: 'bold' }}
                          />
                        </TableCell>
                        <TableCell align="center">
                          <Chip 
                            label={result.close_panna || '-'}
                            color="primary"
                            size="small"
                            sx={{ fontFamily: 'monospace', fontWeight: 'bold' }}
                          />
                        </TableCell>
                        <TableCell align="center">
                          <Chip 
                            label={result.close_single !== null ? result.close_single : '-'}
                            color="secondary"
                            size="small"
                            sx={{ fontFamily: 'monospace', fontWeight: 'bold' }}
                          />
                        </TableCell>
                        <TableCell align="center">
                          <Chip 
                            label={result.jodi || '-'}
                            color="success"
                            size="small"
                            sx={{ fontFamily: 'monospace', fontWeight: 'bold' }}
                          />
                        </TableCell>
                        <TableCell>
                          <Typography variant="body2">
                            {result.declarer?.username || 'System'}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant="body2" color="textSecondary">
                            {formatDateTime(result.createdAt)}
                          </Typography>
                        </TableCell>
                        {user?.user_type === 'owner' && (
                          <TableCell align="center">
                            <Tooltip title="Delete Result (Reverses all winnings)">
                              <IconButton
                                size="small"
                                color="error"
                                onClick={() => handleDeleteResult(result.id)}
                                disabled={loading}
                              >
                                <DeleteIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                          </TableCell>
                        )}
                      </TableRow>
                    ))}
                    
                    {results.length === 0 && (
                      <TableRow>
                        <TableCell colSpan={9} align="center">
                          <Typography color="textSecondary" sx={{ py: 4 }}>
                            No results found
                          </Typography>
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>

              <TablePagination
                rowsPerPageOptions={[10, 25, 50]}
                component="div"
                count={-1} // Use -1 for unknown count
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </CardContent>
          </Card>
        )}

        {tabValue === 1 && statistics.game_type_stats && (
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Game Type Statistics
              </Typography>
              <TableContainer component={Paper}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Game Type</TableCell>
                      <TableCell align="center">Total Bets</TableCell>
                      <TableCell align="center">Bet Amount</TableCell>
                      <TableCell align="center">Win Amount</TableCell>
                      <TableCell align="center">Profit/Loss</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {statistics.game_type_stats.map((stat) => (
                      <TableRow key={stat.bet_type}>
                        <TableCell>
                          <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                            {stat.game_name}
                          </Typography>
                        </TableCell>
                        <TableCell align="center">
                          <Typography variant="body2">
                            {stat.total_bets}
                          </Typography>
                        </TableCell>
                        <TableCell align="center">
                          <Typography variant="body2" sx={{ color: 'primary.main' }}>
                            {formatCurrency(stat.total_bet_amount)}
                          </Typography>
                        </TableCell>
                        <TableCell align="center">
                          <Typography variant="body2" sx={{ color: 'error.main' }}>
                            {formatCurrency(stat.total_win_amount)}
                          </Typography>
                        </TableCell>
                        <TableCell align="center">
                          <Typography 
                            variant="body2" 
                            sx={{ 
                              color: stat.profit >= 0 ? 'success.main' : 'error.main',
                              fontWeight: 'bold' 
                            }}
                          >
                            {formatCurrency(stat.profit)}
                          </Typography>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </CardContent>
          </Card>
        )}

        {/* Declare Result Dialog */}
        <Dialog 
          open={declareDialogOpen} 
          onClose={() => {
            setDeclareDialogOpen(false);
            setActiveStep(0);
            resetDeclareForm();
          }}
          maxWidth="md" 
          fullWidth
        >
          <DialogTitle>Declare Matka Result</DialogTitle>
          <DialogContent>
            <Stepper activeStep={activeStep} orientation="vertical">
              {steps.map((step, index) => (
                <Step key={step.label}>
                  <StepLabel>{step.label}</StepLabel>
                  <StepContent>
                    {step.content}
                    <Box sx={{ mt: 2, display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                      <Button
                        variant="contained"
                        onClick={index === steps.length - 1 ? handleDeclareResult : handleNext}
                        disabled={loading}
                      >
                        {index === steps.length - 1 ? 'Declare Result' : 'Continue'}
                      </Button>
                      {/* Preview Button - Show on step 2 (Enter Results) and step 3 (Confirm) */}
                      {index >= 1 && (declareForm.openPanna || declareForm.closePanna) && (
                        <Button
                          variant="outlined"
                          color="info"
                          onClick={handlePreviewWinners}
                          disabled={previewLoading || loading}
                          startIcon={<PreviewIcon />}
                        >
                          {previewLoading ? 'Loading...' : 'Preview Winners'}
                        </Button>
                      )}
                      <Button
                        disabled={index === 0}
                        onClick={handleBack}
                      >
                        Back
                      </Button>
                    </Box>
                  </StepContent>
                </Step>
              ))}
            </Stepper>
          </DialogContent>
          <DialogActions>
            <Button 
              onClick={() => {
                setDeclareDialogOpen(false);
                setActiveStep(0);
                resetDeclareForm();
              }}
            >
              Cancel
            </Button>
          </DialogActions>
        </Dialog>

        {/* Preview Winners Dialog */}
        <Dialog
          open={previewDialogOpen}
          onClose={() => setPreviewDialogOpen(false)}
          maxWidth="lg"
          fullWidth
          PaperProps={{
            sx: { height: '90vh', maxHeight: '900px' }
          }}
        >
          <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Box display="flex" alignItems="center" gap={1}>
              <PreviewIcon color="info" />
              <Typography variant="h6">Preview Potential Winners</Typography>
            </Box>
            <IconButton onClick={() => setPreviewDialogOpen(false)}>
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent dividers>
            {previewData && (
              <Box>
                {/* Summary Cards */}
                <Grid container spacing={2} sx={{ mb: 3 }}>
                  <Grid item xs={12} sm={6} md={3}>
                    <Paper sx={{ p: 2, textAlign: 'center', bgcolor: 'primary.lighter' }}>
                      <Typography variant="h4" color="primary.main" fontWeight="bold">
                        {previewData.summary?.total_pending_bets || 0}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">Total Pending Bets</Typography>
                    </Paper>
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <Paper sx={{ p: 2, textAlign: 'center', bgcolor: 'success.lighter' }}>
                      <Typography variant="h4" color="success.main" fontWeight="bold">
                        {previewData.summary?.winning_bets || 0}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">Potential Winners</Typography>
                    </Paper>
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <Paper sx={{ p: 2, textAlign: 'center', bgcolor: 'error.lighter' }}>
                      <Typography variant="h4" color="error.main" fontWeight="bold">
                        ₹{(previewData.summary?.total_potential_payout || 0).toLocaleString('en-IN')}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">Total Payout</Typography>
                    </Paper>
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <Paper sx={{ p: 2, textAlign: 'center', bgcolor: previewData.summary?.potential_profit_loss >= 0 ? 'success.lighter' : 'error.lighter' }}>
                      <Typography variant="h4" color={previewData.summary?.potential_profit_loss >= 0 ? 'success.main' : 'error.main'} fontWeight="bold">
                        ₹{(previewData.summary?.potential_profit_loss || 0).toLocaleString('en-IN')}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">Potential Profit/Loss</Typography>
                    </Paper>
                  </Grid>
                </Grid>

                {/* Simulated Result Display */}
                <Card sx={{ mb: 3 }}>
                  <CardContent>
                    <Typography variant="h6" gutterBottom>
                      <CasinoIcon sx={{ mr: 1, verticalAlign: 'middle' }} />
                      Simulated Result for {previewData.market?.name}
                    </Typography>
                    <Grid container spacing={2}>
                      <Grid item xs={6} md={3}>
                        <Typography variant="body2" color="text.secondary">Open Panna</Typography>
                        <Typography variant="h5" color="primary.main">
                          {previewData.simulated_result?.open_panna || '—'}
                        </Typography>
                        {previewData.simulated_result?.open_type && (
                          <Chip size="small" label={previewData.simulated_result.open_type} color="info" />
                        )}
                      </Grid>
                      <Grid item xs={6} md={3}>
                        <Typography variant="body2" color="text.secondary">Open Single</Typography>
                        <Typography variant="h5" color="secondary.main">
                          {previewData.simulated_result?.open_single ?? '—'}
                        </Typography>
                      </Grid>
                      <Grid item xs={6} md={3}>
                        <Typography variant="body2" color="text.secondary">Close Panna</Typography>
                        <Typography variant="h5" color="primary.main">
                          {previewData.simulated_result?.close_panna || '—'}
                        </Typography>
                        {previewData.simulated_result?.close_type && (
                          <Chip size="small" label={previewData.simulated_result.close_type} color="info" />
                        )}
                      </Grid>
                      <Grid item xs={6} md={3}>
                        <Typography variant="body2" color="text.secondary">Close Single / Jodi</Typography>
                        <Typography variant="h5" color="secondary.main">
                          {previewData.simulated_result?.close_single ?? '—'} / {previewData.simulated_result?.jodi || '—'}
                        </Typography>
                      </Grid>
                    </Grid>
                    {previewData.existing_result && (
                      <Box sx={{ mt: 2, p: 1.5, bgcolor: 'warning.lighter', borderRadius: 1 }}>
                        <Typography variant="body2" color="warning.dark">
                          <strong>Existing Result:</strong> Open: {previewData.existing_result.open_panna || '—'} | 
                          Close: {previewData.existing_result.close_panna || '—'} | 
                          Jodi: {previewData.existing_result.jodi || '—'}
                        </Typography>
                      </Box>
                    )}
                  </CardContent>
                </Card>

                {/* Winners by User */}
                {previewData.winners_by_user && previewData.winners_by_user.length > 0 && (
                  <Card sx={{ mb: 3 }}>
                    <CardContent>
                      <Typography variant="h6" gutterBottom>
                        <TrophyIcon sx={{ mr: 1, verticalAlign: 'middle', color: 'warning.main' }} />
                        Winners by User ({previewData.winners_by_user.length} users)
                      </Typography>
                      <TableContainer>
                        <Table size="small">
                          <TableHead>
                            <TableRow>
                              <TableCell>User</TableCell>
                              <TableCell align="center">Winning Bets</TableCell>
                              <TableCell align="right">Bet Amount</TableCell>
                              <TableCell align="right">Potential Win</TableCell>
                              <TableCell align="center">Details</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {previewData.winners_by_user.map((userWin, idx) => (
                              <React.Fragment key={idx}>
                                <TableRow 
                                  hover 
                                  sx={{ cursor: 'pointer', bgcolor: previewExpanded[idx] ? 'action.selected' : 'inherit' }}
                                  onClick={() => setPreviewExpanded(prev => ({ ...prev, [idx]: !prev[idx] }))}
                                >
                                  <TableCell>
                                    <Box display="flex" alignItems="center" gap={1}>
                                      <PersonIcon fontSize="small" color="primary" />
                                      <Box>
                                        <Typography variant="body2" fontWeight="bold">{userWin.user?.username}</Typography>
                                        <Typography variant="caption" color="text.secondary">{userWin.user?.user_type}</Typography>
                                      </Box>
                                    </Box>
                                  </TableCell>
                                  <TableCell align="center">
                                    <Chip size="small" label={userWin.total_bets} color="primary" />
                                  </TableCell>
                                  <TableCell align="right">₹{userWin.total_bet_amount?.toLocaleString('en-IN')}</TableCell>
                                  <TableCell align="right">
                                    <Typography color="success.main" fontWeight="bold">
                                      ₹{userWin.total_potential_win?.toLocaleString('en-IN')}
                                    </Typography>
                                  </TableCell>
                                  <TableCell align="center">
                                    <IconButton size="small">
                                      <ExpandMoreIcon sx={{ transform: previewExpanded[idx] ? 'rotate(180deg)' : 'rotate(0deg)', transition: '0.2s' }} />
                                    </IconButton>
                                  </TableCell>
                                </TableRow>
                                {/* Expanded bet details */}
                                {previewExpanded[idx] && userWin.bets?.map((bet, betIdx) => (
                                  <TableRow key={`${idx}-${betIdx}`} sx={{ bgcolor: 'grey.50' }}>
                                    <TableCell colSpan={5} sx={{ pl: 6 }}>
                                      <Box display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap" gap={1}>
                                        <Chip size="small" label={bet.bet_type} variant="outlined" />
                                        <Typography variant="body2">
                                          <strong>Number:</strong> {bet.number} | <strong>Mode:</strong> {bet.game_mode}
                                        </Typography>
                                        <Typography variant="body2">
                                          <strong>Bet:</strong> ₹{bet.bet_amount} × {bet.multiplier} = 
                                          <Typography component="span" color="success.main" fontWeight="bold" sx={{ ml: 0.5 }}>
                                            ₹{bet.potential_win_amount?.toLocaleString('en-IN')}
                                          </Typography>
                                        </Typography>
                                        <Typography variant="caption" color="info.main">
                                          {bet.win_reason}
                                        </Typography>
                                      </Box>
                                    </TableCell>
                                  </TableRow>
                                ))}
                              </React.Fragment>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </CardContent>
                  </Card>
                )}

                {/* No Winners Message */}
                {(!previewData.winners_by_user || previewData.winners_by_user.length === 0) && (
                  <Box sx={{ textAlign: 'center', py: 4 }}>
                    <TrophyIcon sx={{ fontSize: 60, color: 'grey.400', mb: 2 }} />
                    <Typography variant="h6" color="text.secondary">No Potential Winners</Typography>
                    <Typography variant="body2" color="text.secondary">
                      No bets match the simulated result for this market and date.
                    </Typography>
                  </Box>
                )}

                {/* All Potential Winners Table */}
                {previewData.potential_winners && previewData.potential_winners.length > 0 && (
                  <Card>
                    <CardContent>
                      <Typography variant="h6" gutterBottom>
                        <MoneyIcon sx={{ mr: 1, verticalAlign: 'middle', color: 'success.main' }} />
                        All Winning Bets ({previewData.potential_winners.length})
                      </Typography>
                      <TableContainer sx={{ maxHeight: 300 }}>
                        <Table size="small" stickyHeader>
                          <TableHead>
                            <TableRow>
                              <TableCell>Bet ID</TableCell>
                              <TableCell>User</TableCell>
                              <TableCell>Bet Type</TableCell>
                              <TableCell>Number</TableCell>
                              <TableCell>Mode</TableCell>
                              <TableCell align="right">Bet Amt</TableCell>
                              <TableCell align="right">Win Amt</TableCell>
                              <TableCell>Reason</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {previewData.potential_winners.map((winner, idx) => (
                              <TableRow key={idx} hover>
                                <TableCell>{winner.bet_id}</TableCell>
                                <TableCell>{winner.user?.username}</TableCell>
                                <TableCell><Chip size="small" label={winner.bet_type} /></TableCell>
                                <TableCell><strong>{winner.number}</strong></TableCell>
                                <TableCell>{winner.game_mode}</TableCell>
                                <TableCell align="right">₹{winner.bet_amount}</TableCell>
                                <TableCell align="right">
                                  <Typography color="success.main" fontWeight="bold">
                                    ₹{winner.potential_win_amount?.toLocaleString('en-IN')}
                                  </Typography>
                                </TableCell>
                                <TableCell>
                                  <Tooltip title={winner.win_reason}>
                                    <Typography variant="caption" noWrap sx={{ maxWidth: 150, display: 'block' }}>
                                      {winner.win_reason}
                                    </Typography>
                                  </Tooltip>
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </CardContent>
                  </Card>
                )}
              </Box>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setPreviewDialogOpen(false)}>Close</Button>
            <Button 
              variant="contained" 
              color="primary"
              onClick={() => {
                setPreviewDialogOpen(false);
                // Go to confirm step if not already there
                if (activeStep < 2) setActiveStep(2);
              }}
            >
              Proceed to Declare
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
    </motion.div>
  );
};

export default MatkaDeclareResults;